import React from 'react'

import {ReactComponent as IconoDireccion} from './../imagenes/direccion.svg';
import {ReactComponent as IconoDireccion1} from './../imagenes/direccion1.svg';
import {ReactComponent as IconoMetro} from './../imagenes/metro.svg';
import {ReactComponent as IconoHospital} from './../imagenes/hospital.svg';
import {ReactComponent as IconoAeropuerto} from './../imagenes/aeropuerto.svg';
import {ReactComponent as IconoOtros} from './../imagenes/otros.svg';

const IconoTipoDireccion = ({tipo}) => {
    
    switch(tipo[0]){
        case 'premise':
            return <IconoDireccion1/>;
        case 'route':
            return <IconoDireccion/>;
        case 'subway_station':
            return <IconoMetro/>;
        case 'hospital':
            return <IconoHospital/>;
        case 'airport':
            return <IconoAeropuerto/>;
        default:
            return <IconoOtros/>;
            break;
            
    }

}
export default IconoTipoDireccion;
 
